<div class="search-bar">
  <input matInput
    type="text"
    placeholder="{{placeholder}}"
    [matAutocomplete]="auto"
    [(ngModel)]="searchText"
    (input)="onTextChange(searchText)"
    (focusin)="onInputHandleFocus($event)"
    (focusout)="onInputLeaveFocus($event)">
  <mat-autocomplete #auto="matAutocomplete"
    (optionSelected)="onSelectItem($event)">
    @for (tag of searchResults; track tag) {
      <mat-option [value]="tag">
        {{tag.name}}
      </mat-option>
    }
  </mat-autocomplete>
</div>
